module.exports = {"averageAttendanceRate":86.85,"secretMeetingsRateAverage":14.08,"numberOfPeoplePerCouncillor":59433.86,"highestAttendanceRate":{"councillorName":"Lucy Troisi","title":"Ward 28, Toronto Centre-Rosedale","attendanceRate":100},"mostMeetingsAttended":{"councillorName":"Gary Crawford","title":"Ward 36, Scarborough Southwest","numberOfMeetings":787}}


//////////////////
// WEBPACK FOOTER
// ./src/data/toronto/cityCouncil.json
// module id = 174
// module chunks = 0